
























import { Component, Prop, Vue } from "vue-property-decorator";
import { PraesidiumYear } from "@/api/models/PraesidiumYear";

@Component
export default class PraesidiumNavigation extends Vue {
    /**
     * List with praesidium years.
     */
    @Prop()
    praesidiumYears: Array<PraesidiumYear>;
}
